<div
  *ngIf="isVisible"
  class="relative z-50"
  aria-labelledby="export-modal-title"
  role="dialog"
  aria-modal="true"
>
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="close()"></div>

  <!-- Modal container -->
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="close()">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="px-6 pt-6 pb-6 relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md"
        (click)="$event.stopPropagation()"
      >
        <!-- Close button -->
        <div class="absolute right-0 top-0 pr-4 pt-4">
          <button
            type="button"
            (click)="close()"
            class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Modal content -->
        <div class="text-center">

          <!-- Validating Step -->
          <div *ngIf="currentStep === 'validating'" class="py-6">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-4">
              <svg class="h-6 w-6 text-primary animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <h3 id="export-modal-title" class="text-lg font-semibold text-gray-900 mb-2">Checking Credits</h3>
            <p class="text-sm text-gray-500">Validating your export request...</p>
          </div>

          <!-- Confirmation Step -->
          <div *ngIf="currentStep === 'confirmation'" class="py-4">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 text-primary">
                <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Confirm Export</h3>

            <div class="bg-gray-50 rounded-lg p-4 mb-4 text-left">
              <div class="space-y-3">
                <div class="flex justify-between text-sm">
                  <span class="text-gray-500">Total Records</span>
                  <span class="text-gray-900 font-medium">{{ totalRecords | number:'1.0-0' }}</span>
                </div>
                <div class="flex justify-between text-sm" *ngIf="validation$ | async as validation">
                  <span class="text-gray-500">Credits Required</span>
                  <span class="text-gray-900 font-medium">{{ validation.credits_required | number:'1.0-0' }}</span>
                </div>
                <div class="flex justify-between text-sm" *ngIf="validation$ | async as validation">
                  <span class="text-gray-500">Credits Available</span>
                  <span class="text-gray-900 font-medium">{{ validation.credits_available | number:'1.0-0' }}</span>
                </div>
              </div>
            </div>

            <p class="text-sm text-gray-500 mb-6">
              This will queue an export job. You'll be notified when it's ready for download.
            </p>

            <div class="flex gap-3">
              <button
                type="button"
                (click)="close()"
                class="flex-1 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
              >
                Cancel
              </button>
              <button
                type="button"
                (click)="onProceed()"
                class="flex-1 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 focus:outline-none"
              >
                Proceed
              </button>
            </div>
          </div>

          <!-- Processing Step -->
          <div *ngIf="currentStep === 'processing'" class="py-6">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-4">
              <svg class="h-6 w-6 text-primary animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Starting Export</h3>
            <p class="text-sm text-gray-500">Please wait while we queue your export...</p>
          </div>

          <!-- Success Step -->
          <div *ngIf="currentStep === 'success'" class="py-4">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100 mb-4">
              <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Export Queued</h3>
            <p class="text-sm text-gray-500 mb-6">
              Your export has been queued successfully. You can track its progress on the Exports page.
            </p>

            <div class="flex gap-3">
              <button
                type="button"
                (click)="close()"
                class="flex-1 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
              >
                Close
              </button>
              <a
                routerLink="/exports"
                (click)="close()"
                class="flex-1 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 focus:outline-none text-center"
              >
                View Exports
              </a>
            </div>
          </div>

          <!-- Insufficient Credits Step -->
          <div *ngIf="currentStep === 'insufficient_credits'" class="py-4">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100 mb-4">
              <svg class="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Insufficient Credits</h3>

            <div class="bg-yellow-50 rounded-lg p-4 mb-4 text-left" *ngIf="validation$ | async as validation">
              <div class="space-y-3">
                <div class="flex justify-between text-sm">
                  <span class="text-gray-500">Credits Required</span>
                  <span class="text-gray-900 font-medium">{{ validation.credits_required | number:'1.0-0' }}</span>
                </div>
                <div class="flex justify-between text-sm">
                  <span class="text-gray-500">Credits Available</span>
                  <span class="text-red-600 font-medium">{{ validation.credits_available | number:'1.0-0' }}</span>
                </div>
              </div>
            </div>

            <p class="text-sm text-gray-500 mb-6">
              {{ errorMessage }}
            </p>

            <div class="flex gap-3">
              <button
                type="button"
                (click)="close()"
                class="flex-1 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
              >
                Cancel
              </button>
              <a
                routerLink="/billing"
                (click)="close()"
                class="flex-1 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 focus:outline-none text-center"
              >
                Buy Credits
              </a>
            </div>
          </div>

          <!-- Error Step -->
          <div *ngIf="currentStep === 'error'" class="py-4">
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 mb-4">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Export Failed</h3>
            <p class="text-sm text-gray-500 mb-6">
              {{ errorMessage || 'An error occurred while processing your export request.' }}
            </p>

            <div class="flex gap-3">
              <button
                type="button"
                (click)="close()"
                class="flex-1 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
              >
                Cancel
              </button>
              <button
                type="button"
                (click)="onRetry()"
                class="flex-1 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 focus:outline-none"
              >
                Retry
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
